module.exports = __webpack_public_path__ + "img/cloud5.fefd92fe.png";